if (!customElements.get('refine-filters')) {
  customElements.define(
    'refine-filters',
    class RefineFilters extends HTMLElement {
      connectedCallback() {
        setTimeout(() => this.init(), 0);
      }

      init() {
        if (this.initialized) return;
        this.initialized = true;

        const ratingInputs = Array.from(this.querySelectorAll('.refine-filters__rating'));
        const discountInputs = Array.from(this.querySelectorAll('.refine-filters__discount'));

        // Restore state from URL parameters if present
        const urlParams = new URLSearchParams(window.location.search);
        const ratingParam = urlParams.get('rating');
        const discountParam = urlParams.get('discount');

        if (ratingParam) {
          ratingInputs.forEach((i) => {
            if (i.dataset.minRating === ratingParam) i.checked = true;
          });
        }
        if (discountParam) {
          discountInputs.forEach((i) => {
            if (i.dataset.minDiscount === discountParam) i.checked = true;
          });
        }

        const handleFilterChange = (e) => {
          const rInputs = Array.from(this.querySelectorAll('.refine-filters__rating'));
          const dInputs = Array.from(this.querySelectorAll('.refine-filters__discount'));
          if (e.target.classList.contains('refine-filters__rating')) {
            rInputs.forEach((i) => {
              if (i !== e.target) i.checked = false;
            });
          }
          if (e.target.classList.contains('refine-filters__discount')) {
            dInputs.forEach((i) => {
              if (i !== e.target) i.checked = false;
            });
          }
          this.applyFilters(true);
        };

        [...ratingInputs, ...discountInputs].forEach((input) => {
          input.addEventListener('change', handleFilterChange);
        });

        // Listen for Shopify AJAX facet updates
        document.addEventListener('facets:updated', () => this.applyFilters(false));

        // Observe grid mutations
        const grid = document.getElementById(this.dataset.gridId || 'product-grid');
        if (grid) {
          this.observer = new MutationObserver(() => this.applyFilters(false));
          this.observer.observe(grid, { childList: true });
        }

        // Initial filter check
        this.applyFilters(false);
      }

      applyFilters(updateUrl = false) {
        const grid = document.getElementById(this.dataset.gridId || 'product-grid');
        if (!grid) return;

        const ratingInputs = Array.from(this.querySelectorAll('.refine-filters__rating'));
        const discountInputs = Array.from(this.querySelectorAll('.refine-filters__discount'));

        const checkedRating = ratingInputs.find((input) => input.checked);
        const checkedDiscount = discountInputs.find((input) => input.checked);

        const minRating = checkedRating ? Number(checkedRating.dataset.minRating) : null;
        const minDiscount = checkedDiscount ? Number(checkedDiscount.dataset.minDiscount) : null;

        if (updateUrl) {
          const url = new URL(window.location.href);
          if (minRating !== null) {
            url.searchParams.set('rating', minRating);
          } else {
            url.searchParams.delete('rating');
          }
          if (minDiscount !== null) {
            url.searchParams.set('discount', minDiscount);
          } else {
            url.searchParams.delete('discount');
          }
          window.history.replaceState({}, '', url.toString());
        }

        const items = Array.from(grid.children);
        let visibleCount = 0;

        items.forEach((item) => {
          if (item.tagName !== 'LI') return;
          const ratingAttr = item.getAttribute('data-rating');
          const rating = ratingAttr !== null && ratingAttr !== '' ? Number(ratingAttr) : 5;
          const discount = Number(item.getAttribute('data-discount') || 0);

          const passesRating = minRating === null || rating >= minRating;
          const passesDiscount = minDiscount === null || discount >= minDiscount;

          if (passesRating && passesDiscount) {
            item.style.setProperty('display', '', 'important');
            item.removeAttribute('hidden');
            visibleCount++;
          } else {
            item.style.setProperty('display', 'none', 'important');
            item.setAttribute('hidden', 'hidden');
          }
        });

        // Update product count text if filters active
        if (minRating !== null || minDiscount !== null) {
          const countContainers = document.querySelectorAll('#ProductCount, #ProductCountDesktop');
          countContainers.forEach((container) => {
            container.textContent = `${visibleCount} ${visibleCount === 1 ? 'product' : 'products'}`;
          });
        }

        // Toggle Clear Filters Button visibility in sidebar
        const clearWrappers = document.querySelectorAll('.refine-filters__clear-wrapper');
        clearWrappers.forEach((wrapper) => {
          if (minRating !== null || minDiscount !== null) {
            wrapper.style.display = 'block';
          } else {
            wrapper.style.display = 'none';
          }
        });

        // Toggle Empty State Message (No products found)
        const emptyMsg = document.getElementById('RefineFiltersEmptyMessage');
        if (emptyMsg) {
          if (visibleCount === 0) {
            emptyMsg.style.setProperty('display', 'flex', 'important');
          } else {
            emptyMsg.style.setProperty('display', 'none', 'important');
          }
        }
      }
    }
  );
}

window.clearRefineFilters = function () {
  const elem = document.querySelector('refine-filters');
  if (elem) {
    elem.querySelectorAll('input[type="checkbox"]').forEach((i) => (i.checked = false));
    elem.applyFilters(true);
  }
  const clearLink = document.querySelector('.active-facets__button-remove');
  if (clearLink) {
    window.location.href = clearLink.href;
  }
};
